<!-- <h1>Comp Renewal Premium Info</h1> -->

<div class="PremiumInfo">
    <div class="Loading" *ngIf="isShowLoading==true">
        <img id="" src="assets/img/762.gif" />
        <label>{{'Please Wait,Processing..' | translate }}</label>
    </div>

    <!-- <div class="alert alert-danger">
                <strong>{{Lng=='ar'?prObj.st.StatusDescAr:prObj.st.StatusDesc }}.</strong> 
    </div> -->

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card" style="width:100%;" id="InsuredInfo">
            <ul class="nav nav-tabs listdata" role="tablist">
                <li role="presentation" class="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab"> {{'Premium Details' | translate
                        }}</a>
                </li>

            </ul>
            <div class="tab-content detailsTab">
                <div role="tabpanel" class="tab-pane active" id="home">

                    <div class="row">
                        <div class="col-lg-7 col-md-7 col-sm-8 col-xs-12">
                            <div class="PolicyPeriodInfo">

                                <div class="card" style="width:100%;">
                                    <ul *ngIf="objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode=='5520'" class="nav nav-tabs Sublistdata" role="tablist">
                                        <li  role="presentation" class="active">
                                            <a href="#home" aria-controls="home" role="tab" data-toggle="tab">
                                                {{'Comprehensive Price in SAR' | translate }} </a>

                                        </li>
                                    </ul>
                                    <ul *ngIf="objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode=='5515'" class="nav nav-tabs Sublistdata" role="tablist">
                                        <li *ngIf="objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode=='5515'" role="presentation" class="active">
                                            <a href="#home" aria-controls="home" role="tab" data-toggle="tab">
                                                {{'TPL Price in SAR' | translate }} </a>

                                        </li>

                                    </ul>
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane active PolicyInfo Premium">

                                            <label *ngIf="objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode=='5520'">
                                                <span class="lbltext"> {{'Loss or damage to insured vehicle' |
                                                    translate }}:</span>
                                                <span>{{ BASIC | number : '1.2-2' }}</span>
                                            </label>

                                            <label *ngIf="objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode=='5515'">
                                                <span class="lbltext"> {{'Third Party Civil Liability Insurance' | translate }}:</span>
                                                 <span>{{ BASIC | number : '1.2-2' }}</span>

                                            </label>
                                            <label *ngIf="objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode=='5520'">
                                                <span class="lbltext"> {{'Civil liability to third party for death, bodily injured and Property damage' | translate }}:</span>
                                                <span>{{0.00 | number : '1.2-2'}}</span>

                                            </label>
                                            <label >
                                                <span class="lbltext"> {{'Admin Fee' | translate }}:</span>
                                                <span>{{ADMIN_FEE | number : '1.2-2'}}</span>

                                            </label>
                                            <label  *ngIf="objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode=='5520'">
                                                <span class="lbltext"> {{'Natural Disasters' | translate }}:</span>
                                                <span>{{0.00 | number : '1.2-2'}}</span>

                                            </label>

                                            <label *ngIf="CLAIM_LOADING>0">
                                                <span class="lbltext">{{'Claim Loading' | translate }} :</span>
                                                <span>{{CLAIM_LOADING | number :
                                                    '1.2-2'}}</span>

                                            </label>


                                            <!-- start of Additional Covers -->


                                            <label *ngIf="DAB!=0">
                                                <span class="lbltext"> {{'DAB'| translate }}:</span>
                                                <span>{{DAB | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="PAB!=0">
                                                <span class="lbltext"> {{'PAB' | translate }}:</span>
                                                <span>{{PAB | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="CAL!=0">
                                                <span class="lbltext"> {{'Comprehensive additional Loading' | translate
                                                    }}:</span>
                                                <span>{{CAL | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="BAHRAIN!=0">
                                                <span class="lbltext"> {{'Bahrain Only' | translate }}:</span>
                                                <span>{{BAHRAIN | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="AGE_LOADING!=0">
                                                <span class="lbltext"> {{'Age Loading' | translate }}:</span>
                                                <span>{{AGE_LOADING | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="Geographical_Inc_Bahrain
                                            !=0">
                                                <span class="lbltext"> {{'Geographical Extension to GCC Including
                                                    Bahrain' | translate }}:</span>
                                                <span>{{Geographical_Inc_Bahrain | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="Geographical_EJL
                                            !=0">
                                                <span class="lbltext"> {{'Geographical Extension to Egypt, Jordan,
                                                    Lebanon' | translate }}:</span>
                                                <span>{{Geographical_EJL| number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="ZERO_DEP
                                            !=0">
                                                <span class="lbltext"> {{'Zero Depreciation' | translate }}:</span>
                                                <span>{{ZERO_DEP | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="VEHICLE_REP
                                            !=0">
                                                <span class="lbltext"> {{'Replacement Vehicle up to 100 RS per day' |
                                                    translate }}:</span>
                                                <span>{{VEHICLE_REP
                                                    | number : '1.2-2'}}</span>

                                            </label>

                                            <!-- end of Additional Covers -->


                                            <label>
                                                <span class="lbltext"> {{'Gross Premium' | translate }}:</span>
                                                <span>{{GROSS_AMOUNT | number : '1.2-2'}}</span>

                                            </label>
                                            <label>
                                                <span class="lbltext"> {{'NCD' | translate }}:</span>
                                                <span class="Percent" >{{ NCD_AMOUNT | number : '1.2-2'}}({{NCD_PER | number :
                                                    '1.2-2'}}%)</span>

                                            </label>

                                            <label>
                                                <span class="lbltext"> {{'LD Discount' | translate }}:</span>
                                                <span class="Percent">{{ LD_AMOUNT | number : '1.2-2'}}({{LD_PER | number : '1.2-2'}}%)</span>

                                            </label>


                                            <label *ngIf="DRIVER_DISC_AMOUNT>0">
                                                <span class="lbltext">{{'Female Discount' | translate }} :</span>
                                                <span class="Percent">{{DRIVER_DISC_AMOUNT | number :
                                                    '1.2-2'}}({{DRIVER_DISC_PER | number : '1.2-2'}}%)</span>

                                            </label>


                                            <label *ngIf="PROMO_DISC_AMOUNT>0">
                                                <span class="lbltext"> {{'Promo Discount' | translate}}:</span>
                                                <span class="Percent">{{PROMO_DISC_AMOUNT | number : '1.2-2'}}({{PROMO_DISC_PER |
                                                    number : '1.2-2' }}%)
                                                </span>

                                            </label>
                                            <label *ngIf="OTHER_DISC_AMOUNT>0">
                                                <span  class="lbltext"> {{'Scheme Discount'| translate}}:</span>
                                                <span class="Percent">{{OTHER_DISC_AMOUNT | number : '1.2-2'}}({{OTHER_DISC_PER |
                                                    number : '1.2-2'}}%)</span>

                                            </label>
                                            <label>
                                                <span class="lbltext"> {{'Total(Excluding VAT)' | translate }}:</span>
                                                <span>{{TOTAL_EXC_VAT | number : '1.2-2'}}</span>

                                            </label>
                                            <label>
                                                <span class="lbltext">{{'VAT' | translate }}:</span>
                                                <span class="Percent">{{VAT_AMOUNT | number : '1.2-2'}}({{5 |
                                                    number : '1.2-2'}}%)</span>

                                            </label>
                                            <label *ngIf="UPR_VAT_AMOUNT>0">
                                                <span class="lbltext">{{'UPR VAT' | translate }} :</span>
                                                <span>{{UPR_VAT_AMOUNT | number :
                                                    '1.2-2'}}</span>

                                            </label>
                                            <label class="Total">
                                                <span> {{'Total' | translate }}:</span>
                                                <span>{{TOTAL_PREMIUM | number : '1.2-2'}}</span>

                                            </label>
                                            <!-- <label style="color:red;">Total: 1684 SAR</label>  -->
                                            <div class="btncomprehensivediv row">
                                                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 addcoverdiv">
                                                    <button class="btn btn-primary addcovers" data-toggle="modal"
                                                        data-target="#AdditionalCoversModal">{{'Add More Covers' |
                                                        translate }}</button>
                                                </div>
                                                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 viewcoverdiv">
                                                    <span class="coversdisplay">
                                                        <a class="viewcovers" style="color: rgb(17, 173, 69);"
                                                            [routerLink]="" (click)="CoverViews()">{{'View Cover
                                                            Details'| translate}}</a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>


                    <div class="row">

                        <div class="promo">
                            <div class="Field">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <label class="lbltext"> {{'Do you have promo code?' | translate }}</label>
                                    </div>
                                    <div class="col-lg-12 row">
                                        <div class="col-lg-5 col-md-6 col-sm-6 col-xs-6 promocodeinput">
                                            <input class="form-control" id="txtPromo" id="txtPromo" placeholder="Promo Code"
                                                type="text" [(ngModel)]="promocode" >
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                            <button class="btn btn-primary" id="btnRenewalPromo" name="btnRenewalPromo"
                                                (click)="CheckPromoCode(promocode)">{{'Apply' | translate }}</button>
                                        </div>


                                    


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <hr class="hr" />
                    </div>

                    <!-- <div class="ButtonActions ">
                        <div class="btn-group">
                            
                            <button class="btn btn-primary" name="btnNext" id="btnNext" (click)="goNext()">{{'Next' |
                                translate }}</button>
                        </div>
                    </div> -->
                    <div class="row">

                        <div class="btn-group btnactions">
                            <button class="btn btn-primary" name="btnPrev" id="btnPrev" (click)="Prev()">{{'Prev'
                                |
                                translate }}</button>
                            <button class="btn btn-primary" name="btnNext" id="btnNext" (click)="goNext()">{{'Next'
                                |
                                translate }}</button>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</div>



<div class="clears">

</div>

<!-- Additional Comp Covers -->
<div class="modal fade" id="AdditionalCoversModal" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <h4 *ngIf="objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode=='5520'" class="modal-title logins">{{'Additional Comprehensive Covers' | translate}}</h4>
                <h4 *ngIf="objPremiumAndVehicleInfoRes.POLICY_INFO.ProductCode=='5515'" class="modal-title logins">{{'Additional TPL Covers' | translate}}</h4>
            </div>
            <div class="modal-body">

                <div class="ComprensivePremium">
                    <form #tplCoverForm="ngForm">
                        <table class="table table-striped tabledesign">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{{'Cover Description'}} </th>
                                    <th style="min-width:130px">{{'Total Price'}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let addcover of objPremiumAndVehicleInfoRes.PREMIUM_INFO.AdditionalCovers">
                                    <td> <input id="txtSelected" name="txtSelected" type="checkbox" style="zoom:1.3"
                                            (change)="AdditionalCoversCheck($event,addcover.CoverCode)" [checked]="addcover.IsMandatory" /></td>
                                    <td>{{ Lng=="en"? addcover.CoverDescription: addcover.CoverDescription_Ar }}</td>
                                    <td>{{ addcover.GrossAmount | number : '1.2-2' }}</td>
                                </tr>


                            </tbody>
                        </table>


                        <div class="Actionsection">
                            <div class="Actions">
                                <div class="btn-group">

                                    <button type="button" class="btn btn-primary btns procced" data-dismiss="modal">{{'Proceed'|translate}}</button>

                                </div>
                            </div>
                        </div>
                    </form>

                </div>


            </div>

        </div>
    </div>

</div>
<!-- Additional TPL Covers -->


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/CompRenewalPremiumInfo/CompRenewalPremiumInfo.html